import {css} from '@emotion/css';
import {colours} from '@fo/shared/styles/variables/colours';
import {spacing} from '@fo/shared/styles/variables/spacing';

const styles = {
  dropdown: css`
    label: dropdown;
    position: relative;
  `,

  button: css`
    label: dropdown__button;
    display: inline-flex;
    align-items: center;
    padding: 0;
  `,

  icon: css`
    label: dropdown__icon;
  `,

  panel: (isOpen: boolean): string => css`
    label: dropdown__panel;
    position: absolute;
    top: calc(100% + 0.4rem);
    right: 0;
    min-width: 18rem;
    padding: 0.6rem ${spacing.XXS}; // stylelint-disable-line sh-waqar/declaration-use-variable
    background-color: ${colours.general.WHITE};
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);

    ${isOpen
      ? css`
          display: block;
        `
      : css`
          display: none;
        `}
  `,
};

export default styles;
